import { RightOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';
import React from 'react';
import BarCard from "./BarCard";

type IndicatorCardItem = {
    label: string | ReactNode;
    value: number | string | ReactNode;
    color?: 'red' | 'green' | 'blue' | 'yellow' | 'purple' | 'orange' | 'gray';
    onClick?: () => void;
    showArrow?: boolean; // 新增：控制是否显示箭头，但不需要点击功能
    alignment?: 'left' | 'center' | 'right'; // 新增：控制文本对齐方式
    backgroundColor?: string; // 新增：背景颜色类名
}

type IndicatorCardProps = {
    title: string | React.ReactNode;
    items: IndicatorCardItem[];
}

const IndicatorCard = ({
    title,
    items
}: IndicatorCardProps) => {
    return (
        <BarCard title={title}>
            <div className="flex gap-2.5">
                {items.map((item, index) => (
                    <div 
                        key={index} 
                        className={`${item.alignment ? "flex flex-col gap-1 items-" + item.alignment : "flex flex-col gap-1 items-center"} ${item.backgroundColor || ''} ${item.onClick ? 'cursor-pointer' : ''} p-2 rounded-lg transition-colors duration-200`}
                        onClick={item.onClick}
                    >
                        <div className="flex items-center gap-1">
                            {React.isValidElement(item.value) ? item.value : <div className={item.color ? "text-lg text-" + item.color + "-500" : "text-lg"}>{item.value}</div>}
                            {item.showArrow && (
                                <div className="text-gray-400 text-sm">
                                    <RightOutlined />
                                </div>
                            )}
                        </div>
                        {React.isValidElement(item.label) ? item.label : <p className="text-xs text-gray-400">{item.label}</p>}
                    </div>
                ))}
            </div>
        </BarCard>
    )
};

export default IndicatorCard;